import React, { useState } from 'react'
import { Card, Separator, H2, Button, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import TrainingDataItem from './TrainingDataItem'
import { type SearchResult } from '../types'

type TrainingDataPanelProps = Readonly<{
  draggedItems: SearchResult[]
  searchQuery: string
}>

const TrainingDataPanel = ({ draggedItems, searchQuery }: TrainingDataPanelProps) => {
  const [t] = useTranslation()
  const [copied, setCopied] = useState(false)

  const handleCopyToClipboard = async () => {
    try {
      const trainingData = draggedItems.map((result, index) => ({
        searchQuery,
        placeId: result.id,
        score: result.score,
        rank: index + 1,
        originalRank: result.originalIndex,
        fullDisplayName: result.fullDisplayName,
        names: result.names,
      }))

      const jsonString = JSON.stringify(trainingData, null, 2)
      await navigator.clipboard.writeText(jsonString)

      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy to clipboard:', err)
    }
  }

  return (
    <>
      <H2 size="H5">{t('place-learn-to-rank-page.training-data-panel.training-data.heading', 'Training Data')}</H2>
      <Separator />

      <Card backgroundColor={colors.gray02}>
        <Separator />
        {draggedItems.map((result) => (
          <TrainingDataItem key={result.id} result={result} searchQuery={searchQuery} />
        ))}
        <Separator />
        <Button emphasis="high" onClick={handleCopyToClipboard}>
          {copied
            ? t('place-learn-to-rank-page.training-data-panel.copied.button', 'Copied!')
            : t('place-learn-to-rank-page.training-data-panel.copy-to-clipboard.button', 'Copy to Clipboard')}
        </Button>
      </Card>
    </>
  )
}

export default TrainingDataPanel
